module.exports = __webpack_public_path__ + "img/payz.9dd21497.png";